<template>
	<div
			v-click-outside.capture="handleClose"
			v-click-outside:mousedown.capture="handleClose"
	>
		<Dropdown class="wms-auto-complete" :transfer="transfer" placement="bottom-start" trigger="custom" @on-click="onClick" :visible="!disabled && dropDownShow">
			<div @click="handleOpen">
				<Input :autofocus="autofocus" @on-focus="inputFocus" @input="onChange" :value="value" :size="size" :placeholder="placeholder" :disabled="disabled" ref="input" :readonly="readonly"/>
			</div>
			<DropdownMenu slot="list">
				<ul class="ivu-select-not-found" v-show="dataSourceFilter.length===0 && loading===false">
					<li> 无匹配数据</li>
				</ul>
				<ul class="ivu-select-loading" v-show="loading===true">
					<li> 加载数据中 <i class="ivu-load-loop ivu-icon ivu-icon-load-c"></i></li>
				</ul>
				<DropdownItem v-for="(item,index) in dataSourceFilter" :title="item" :key="index" :name="item">{{item}}</DropdownItem>
			</DropdownMenu>
		</Dropdown>
	</div>
</template>

<script>
import {directive as clickOutside} from 'v-click-outside-x'

export default {
    name: 'autoCompleteCustom',
    directives: {clickOutside},
    data() {
        return {
            visible: false
        }
    },
    props: {
        dataSource: {
            type: Array,
            default: function() {
                return []
            }
        },
        value: {
            type: [Number, String]
        },
        loading: {
            type: Boolean,
            default: false
        },
        filterMethod: {
            type: [Function, Boolean]
        },
        size: {
            type: String,
            default: 'small'
        },
        placeholder: {
            type: String
        },
        disabled: {
            default: false
        },
        defalutOpen: {
            default: false
        },
        transfer: {
            type: Boolean,
            default: false
        },
        autofocus: {type: Boolean, default: false},
        readonly: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        dropDownShow() {
            return this.defalutOpen ? this.visible : !!this.value && this.value.length > 0 && this.visible
        },
        dataSourceFilter() {
            if (this.filterMethod) {
                return this.dataSource.filter(item => this.filterMethod(this.value, item))
            } else {
                return this.dataSource
            }
        }
    },
    methods: {
        onChange(v, flag = true) {
            // 输入时查询，选择时关闭选择框，不再查询
            flag && this.$emit('on-search', v)
            this.$emit('input', v)
            v && this.toggleMenu(flag)
        },
        onClick(v) {
            this.onChange(v, false)
            this.$emit('on-select', this.value)
        },
        handleOpen() {
            this.toggleMenu(true)
            this.$emit('on-search', this.value)
        },
        handleClose() {
            this.$emit('click-outside', this.value)
            this.toggleMenu(false)
        },
        toggleMenu(flag) {
            this.visible = flag
        },
        inputFocus() {
            this.$emit('on-focus')
        }
    },
    mounted() {
        if (this.autofocus === true) {
            setTimeout(() => {
                this.$refs.input.focus()
                this.handleOpen()
            }, 0)
        }
    }
}
</script>

<style lang="less">
	.wms-auto-complete {
		display: block !important;
		position: relative;
		width: 100%;
		.ivu-dropdown-item {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.ivu-select-dropdown {
			width: 100%;
			top: 30px;
			max-height: 200px;
			overflow-y: auto;
		}
	}

</style>
